import React from "react";

const BrandTicker = () => {
  const logos = [
    { name: "Pelle & Sol", src: "https://customer-assets.emergentagent.com/job_dreibach-site/artifacts/r5e45090_Pelle%20%26%20Sol.png" },
    { name: "Yum Yum", src: "https://customer-assets.emergentagent.com/job_dreibach-site/artifacts/jshx53gf_YumYum.png" },
    { name: "La Donna", src: "https://customer-assets.emergentagent.com/job_dreibach-site/artifacts/hv2pnyng_La%20Donna.png" },
    { name: "GloBrite", src: "https://customer-assets.emergentagent.com/job_dreibach-site/artifacts/5k4d5hi6_Globrite.png" },
    { name: "Tanness", src: "https://customer-assets.emergentagent.com/job_dreibach-site/artifacts/h3hipvo0_Tanness.png" },
    { name: "Fur & Bone", src: "https://customer-assets.emergentagent.com/job_dreibach-site/artifacts/1asvfaza_Fur%20%26%20Bone.png" },
  ];

  // Duplicate the list for the infinite scroll effect
  const tickerItems = [...logos, ...logos, ...logos];

  return (
    <div className="w-full bg-dreibach-black border-b border-white/5 py-10 overflow-hidden relative z-20">
      <div className="container mx-auto px-6 mb-6 text-center">
         <p className="text-xs font-bold uppercase tracking-[0.3em] text-gray-500">
            Our Portfolio of Brands
         </p>
      </div>
      
      <div className="w-full inline-flex flex-nowrap overflow-hidden [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-128px),transparent_100%)]">
        <ul className="flex items-center justify-center md:justify-start [&_li]:mx-8 [&_img]:max-w-none animate-scroll">
          {tickerItems.map((logo, idx) => (
            <li key={idx} className="flex-shrink-0">
              <img 
                src={logo.src} 
                alt={logo.name} 
                className="h-12 w-auto object-contain brightness-0 invert opacity-50 hover:opacity-100 transition-opacity duration-300"
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default BrandTicker;
